import React from "react";
import { Facebook, Instagram, Twitter, Youtube } from "lucide-react";
import { CONTACT } from "../../data/flyzone";

const quickLinks = [
  { label: "Fleet", href: "#fleet" },
  { label: "Why Choose Us", href: "#why" },
  { label: "How It Works", href: "#how" },
  { label: "Reviews", href: "#reviews" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

const socials = [
  { icon: Instagram, href: "#", label: "Instagram" },
  { icon: Facebook, href: "#", label: "Facebook" },
  { icon: Twitter, href: "#", label: "Twitter" },
  { icon: Youtube, href: "#", label: "YouTube" },
];

export const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10 pt-16 pb-8" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <a href="#home" className="flex flex-nowrap items-center gap-2 shrink-0">
              <img src="/flyzone-mark.webp" alt="Flyzone" className="h-11 w-auto shrink-0" />
              <span className="text-2xl font-display font-extrabold whitespace-nowrap leading-none">
                Fly<span className="gold-text">zone</span>
              </span>
            </a>
            <p className="mt-4 text-sm text-white/55 leading-relaxed">
              Premium bike &amp; scooter rentals. Ride your freedom, everywhere you go.
            </p>
            <div className="flex gap-3 mt-5">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  data-testid={`social-${s.label.toLowerCase()}`}
                  className="grid place-items-center w-9 h-9 rounded-full border border-white/15 text-white/70 hover:bg-primary hover:text-black hover:border-primary transition-colors"
                >
                  <s.icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-white/60 hover:text-primary transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-4">Legal</h4>
            <ul className="space-y-2.5">
              <li><a href="#" data-testid="footer-privacy" className="text-sm text-white/60 hover:text-primary transition-colors">Privacy Policy</a></li>
              <li><a href="#" data-testid="footer-terms" className="text-sm text-white/60 hover:text-primary transition-colors">Terms &amp; Conditions</a></li>
              <li><a href="#" className="text-sm text-white/60 hover:text-primary transition-colors">Refund Policy</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-4">Contact</h4>
            <ul className="space-y-2.5 text-sm text-white/60">
              <li>{CONTACT.phone}</li>
              <li>{CONTACT.email}</li>
              <li>
                <a href={CONTACT.websiteUrl} target="_blank" rel="noreferrer" data-testid="footer-website" className="hover:text-primary transition-colors">
                  {CONTACT.website}
                </a>
              </li>
              <li className="leading-relaxed">{CONTACT.address}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/45">© {new Date().getFullYear()} Flyzone Rentals. All rights reserved.</p>
          <p className="text-xs text-white/45">Ride Your Freedom · Crafted with precision</p>
        </div>
      </div>
    </footer>
  );
};
